// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import ListItem from "@/wab/client/components/ListItem";
import { showTemporaryPrompt } from "@/wab/client/components/quick-modals";
import Button from "@/wab/client/components/widgets/Button";
import { Icon } from "@/wab/client/components/widgets/Icon";
import { Modal } from "@/wab/client/components/widgets/Modal";
import ComponentIcon from "@/wab/client/plasmic/plasmic_kit/PlasmicIcon__Component";
import { StudioCtx } from "@/wab/client/studio-ctx/StudioCtx";
import { isBuiltinCodeComponent } from "@/wab/shared/code-components/builtin-code-components";
import { getComponentDisplayName } from "@/wab/shared/core/components";
import { Component } from "@/wab/shared/model/classes";
import { naturalSort } from "@/wab/shared/sort";
import * as React from "react";

type WrapInComponentResponse = Component | undefined;

export async function promptWrapInComponent(props: {
  studioCtx: StudioCtx;
  component: Component;
}) {
  const { studioCtx, component } = props;
  return showTemporaryPrompt<WrapInComponentResponse>((onSubmit, onCancel) => (
    <Modal
      title={"Wrap in component"}
      visible={true}
      footer={null}
      onCancel={() => onCancel()}
    >
      <p>
        Choose the component to wrap the selected items
        <br />
        <small>Only components with a children slot can be used</small>
      </p>
      <div className="flex flex-col">
        {naturalSort(
          studioCtx.site.components
            .filter(
              (c) =>
                c !== component &&
                !isBuiltinCodeComponent(c) &&
                c.params.some((param) => param.variable.name === "children")
            )
            .map((c) => [c, getComponentDisplayName(c)] as const),
          ([_, displayName]) => displayName
        ).map(([c, displayName]) => (
          <ListItem
            icon={<Icon icon={ComponentIcon} />}
            onClick={() => onSubmit(c)}
          >
            {displayName}
          </ListItem>
        ))}
      </div>
      <div className="flex flex-hcenter pt-m">
        <Button onClick={onCancel}>Cancel</Button>
      </div>
    </Modal>
  ));
}
